import { useEffect } from "react";

/**
 * useImmersive — when the content is the picture, the app chrome goes away
 * (Plan G). Sets `data-immersive` on <html>; global.css hides the breadcrumb
 * bar and locks page scroll under it. Removed on unmount or when inactive.
 */
export function useImmersive(active) {
  useEffect(() => {
    if (!active || typeof document === "undefined") return;
    const root = document.documentElement;
    const prev = root.getAttribute("data-immersive");
    root.setAttribute("data-immersive", "1");
    return () => { if (prev === null) root.removeAttribute("data-immersive"); else root.setAttribute("data-immersive", prev); };
  }, [active]);
}
